import { Reducer } from 'redux';
import { PayloadAction } from '@lifesize/typescript-react-redux-utils';
import Authentication from '../state/Authentication';
import { nucleusConstants } from '@lifesize/nucleus';
import { redirectToLogout } from '../utils/url-utils';

const authenticationReducer: Reducer<Authentication> =
  (state = new Authentication(), action: PayloadAction<string, object>) => {
    switch (action.type) {
      case nucleusConstants.LOGOUT_FINISHED:
        const element = document.getElementById('root');
        if (element && element.parentNode) {
          element.parentNode.removeChild(element);
        }
        redirectToLogout();
        return state;
      default:
        return state;
    }
  };

export default authenticationReducer;
